/* eslint-disable */

const spectrumAccountId = 'kfkodizkxo44clckqjzw';
const spectrumChannelid = 'vhlhvzxbguryburepez8';

const config = {
  accountId: spectrumAccountId,
  channelId: spectrumChannelid,
  channelFilter: (c) => {
    return true
  },
  staticChannels: [
  ],
  accountIdMap: {
    'kfkodizkxo44clckqjzw': 'vhlhvzxbguryburepez8',
  },
  spectrumAccountId: spectrumAccountId,
}

const spectrumChannels = {
    'vhlhvzxbguryburepez8': {
      name: 'All Games',
      price: 9.99,
      price_suffix: 'game',
      geoblocked: false,
      preview: '/img/icon_football.png',
      label: '',
      highlight: true,
    },
};

Object.keys(spectrumChannels).forEach((k) => {
  var v = spectrumChannels[k];
  config.staticChannels.push({
    id: k, name: v.name, abbrev: v.label, accountId: spectrumAccountId,
  });
});

export default config;



// WEBPACK FOOTER //
// ./src/config.js